<app-header></app-header>

<div class="root">
	<router-outlet></router-outlet>
</div>
